import type { TeamFitTraits } from "../../types";

const LABELS: Record<keyof TeamFitTraits, string> = {
  communication: "Communication",
  collaboration: "Collaboration",
  leadership: "Leadership",
  problemSolving: "Problem Solving",
  adaptability: "Adaptability",
  integrity: "Integrity",
};

const ORDER: (keyof TeamFitTraits)[] = [
  "communication",
  "collaboration",
  "leadership",
  "problemSolving",
  "adaptability",
  "integrity",
];

export function RadarChart({ traits, size = 260 }: { traits: TeamFitTraits; size?: number }) {
  const center = size / 2;
  const maxRadius = size / 2 - 36;
  const angleStep = (Math.PI * 2) / ORDER.length;

  function pointFor(index: number, ratio: number) {
    const angle = index * angleStep - Math.PI / 2;
    return {
      x: center + Math.cos(angle) * maxRadius * ratio,
      y: center + Math.sin(angle) * maxRadius * ratio,
    };
  }

  const dataPoints = ORDER.map((key, i) => pointFor(i, Math.max(0, Math.min(100, traits[key])) / 100));
  const dataPath = dataPoints.map((p) => `${p.x},${p.y}`).join(" ");

  const rings = [0.25, 0.5, 0.75, 1];

  return (
    <svg width={size} height={size} viewBox={`0 0 ${size} ${size}`}>
      {rings.map((r) => {
        const pts = ORDER.map((_, i) => pointFor(i, r));
        return (
          <polygon
            key={r}
            points={pts.map((p) => `${p.x},${p.y}`).join(" ")}
            fill="none"
            stroke="#E2E8F0"
            strokeWidth={1}
          />
        );
      })}
      {ORDER.map((_, i) => {
        const p = pointFor(i, 1);
        return <line key={i} x1={center} y1={center} x2={p.x} y2={p.y} stroke="#E2E8F0" strokeWidth={1} />;
      })}
      <polygon points={dataPath} fill="#0EA5E9" fillOpacity={0.25} stroke="#0EA5E9" strokeWidth={2} />
      {dataPoints.map((p, i) => (
        <circle key={i} cx={p.x} cy={p.y} r={3} fill="#0EA5E9" />
      ))}
      {ORDER.map((key, i) => {
        const labelPoint = pointFor(i, 1.18);
        return (
          <text
            key={key}
            x={labelPoint.x}
            y={labelPoint.y}
            textAnchor="middle"
            dominantBaseline="middle"
            fontSize={11}
            fill="#334155"
          >
            {LABELS[key]}
          </text>
        );
      })}
    </svg>
  );
}
